// modules/estrategias/rbc/offline/discapacidadOffline.js
// Capa fina sobre crudOfflineFactory.js — ahí vive la lógica real
// (evitar pendientes duplicados al reeditar, soportar eliminar offline).
import { crearCrudOffline } from "../../../inicio/offline/crudOfflineFactory";
import { crearPersonaAPI, actualizarPersonaAPI, deletePersona } from "../api/RBCAPI";

const crud = crearCrudOffline({
  tablaPendientes: "discapacidad_pendientes",
  apiCrear: crearPersonaAPI,
  apiActualizar: actualizarPersonaAPI,
  apiEliminar: deletePersona,
});

// `personaId`: el id del registro que se está editando (real del servidor,
// o "local_N" si todavía no se sincronizaba) — undefined si es creación.
export const guardarOfflineDiscapacidad = (payload, personaId) => crud.guardarOffline(payload, personaId);
export const eliminarOfflineDiscapacidad = (personaId) => crud.eliminarOffline(personaId);
export const contarDiscapacidadPendientes = () => crud.contarPendientes();
export const sincronizarDiscapacidadPendientes = () => crud.sincronizarPendientes();
